import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
  Filler
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend, Filler);

const Goldchart = () => {
  const [chartData, setChartData] = useState(null);
  const [tableData, setTableData] = useState()

  useEffect(() => {
    (async () => {
      try {
        const today = new Date();
        const fiveDaysAgo = new Date();
        fiveDaysAgo.setDate(today.getDate() - 4);

        const formatDate = (date) => date.toISOString().split("T")[0];

        const startDate = formatDate(fiveDaysAgo);
        const endDate = formatDate(today);

        const res = await axios.get(
          `https://api.metalpriceapi.com/v1/timeframe?api_key=95c9a73a337537a8548f9ded540ee8d7&start_date=${startDate}&end_date=${endDate}&base=INR&currencies=XAU`
        );
        const rates = res.data.rates;
        setTableData(Object.entries(rates))
        const dates = Object.keys(rates);
        const prices = dates.map(date => (rates[date].INRXAU / 28.3495) * 10);

        setChartData({
          labels: dates,
          datasets: [
            {
              label: "Gold Price (INR per 10g)",
              data: prices,
              borderColor: "gold",
              tension: 0.3,
              backgroundColor: "rgba(255, 215, 0, 0.3)",
              fill: true,
              pointRadius: 3.5,
              pointHoverRadius: 6,
              pointBackgroundColor: "#ffd900ff",
              pointBorderWidth: 2
            }
          ]
        });

      } catch (err) {
        console.error("Error fetching gold price data:", err);
      }
    })();
  }, []);

  return (
    <section className="gold-section" style={{ padding: "0 15px" }}>
      <div className="container">
        <h2 style={{ textAlign: "center" }}>Gold Price</h2>
        <div className="chart-container" style={{ width: "100%" }}>
          {chartData ? (
            <Line data={chartData} options={{
              responsive: true,
              plugins: {
                legend: {
                  display: true,
                  position: 'top'
                }
              }
            }} />
          ) : (
            <p>Loading chart...</p>
          )}
        </div>
        <table border={1}>
          <thead>
            <tr>
              <th>Date</th>
              <th>24k (10g)</th>
              <th>22k (10g)</th>
              <th>20k (10g)</th>
            </tr>
          </thead>
          <tbody>
            {tableData ? (
              [...tableData]
                .reverse().map(([date, data]) => {
                  const goldPer10g = (data.INRXAU / 28.3495) * 10;
                  
                  const formattedDate = new Date(date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                  });

                  return (
                    <tr key={date}>
                      <td>{formattedDate}</td>
                      <td>
                        ₹
                        {goldPer10g.toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        ₹
                        {(goldPer10g * 0.9167).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        ₹
                        {(goldPer10g * 0.8334).toLocaleString('en-IN', {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  );
                })
            ) : (
              <tr>
                <td colSpan="4">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section >
  );
};

export default Goldchart;
